import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IListaReemplazos, IListaSeccionesReemplazoDocente, IObjReqBodyCrearReemplazoDocente, IReqBodyCrearReemplazoDocente, IResCrearReemplazoDocente } from 'src/app/interfaces/reemplazo-docente';
import { ISeccionesRes } from 'src/app/interfaces/secciones';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReemplazoDocenteService {

  constructor(
    private readonly http: HttpClient
  ) { }

  getHeaders(): HttpHeaders {
    return new HttpHeaders();
  }

  getListaReemplazoDocentes(anyo: number = 0, periodoId: number = 0, sedeId: number = 0, docenteId: number = 0): Observable<IListaReemplazos> {
    const url = `${environment.endpointAdministrativo}/v1/reemplazo-docente/busca-lista-reemplazos-docentes?anyo=${anyo}&periodo-id=${periodoId}&sede-id=${sedeId}&docente-id=${docenteId}`
    return this.http.get<IListaReemplazos>(url, { headers: this.getHeaders() })
  }

  getListaSeccionesReemplazoDocente(anyo: number = 0, periodoId: number = 0, sedeId: number = 0, seccionId: number = 0, docenteId: number = 0): Observable<IListaSeccionesReemplazoDocente> {
    const url = `${environment.endpointAdministrativo}/v1/reemplazo-docente/obtenerSecciones?anyo=${anyo}&periodo-id=${periodoId}&sede-id=${sedeId}&docente-id=${docenteId}&seccion-id=${seccionId}`
    return this.http.get<IListaSeccionesReemplazoDocente>(url, { headers: this.getHeaders() })
  }

  postCrearReemplazoDocente(reqBody: IReqBodyCrearReemplazoDocente): Observable<IResCrearReemplazoDocente> {
    const url = `${environment.endpointAdministrativo}/v1/reemplazo-docente/crear-reemplazo-docente`
    return this.http.post<IResCrearReemplazoDocente>(url, reqBody, { headers: this.getHeaders() })
  }

  deleteReemplazoDocente(reemplazoId: number): Observable<any> {
    const url = `${environment.endpointAdministrativo}/v1/reemplazo-docente/eliminar/${reemplazoId}`
    return this.http.delete<any>(url, { headers: this.getHeaders() })
  }
  
  obtenerListaDocentesBackoffice(anyo: number, periodoId: number, sedeId: number = 0, seccionId: number = 0):Observable<any> {
    const filtroSede = sedeId !== 0 ? `&sede-id=${sedeId}` : ''
    const filtroSeccion = seccionId !== 0 ? `&seccion-id=${seccionId}` : ''
    const url = `${environment.endpointAdministrativo}/v1/reemplazo-docente/obtenerDocentes?anyo=${anyo}&periodo-id=${periodoId}${filtroSede}${filtroSeccion}`
    return this.http.get<any>(url, { headers: this.getHeaders() })
  }

  putEditarReemplazoDocente(reqBody: IObjReqBodyCrearReemplazoDocente, idReemplazo: number): Observable<IResCrearReemplazoDocente> {
    const url = `${environment.endpointAdministrativo}/v1/reemplazo-docente/modificar?reemplazo-id=${idReemplazo}`
    return this.http.put<IResCrearReemplazoDocente>(url, reqBody, { headers: this.getHeaders() })
  }

  getListaSeccionesCrearReemplazoDocente(anyo: number = 0, periodoId: number = 0, sedeId: number = 0):Observable<ISeccionesRes> {
    const url = `${environment.endpointAdministrativo}/v1/reemplazo-docente/crear/obtenerSecciones?anyo=${anyo}&periodo-id=${periodoId}&sede-id=${sedeId}`
    return this.http.get<ISeccionesRes>(url, { headers: this.getHeaders() })
  }
}
